/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line no-use-before-define
import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import 'theme/main.less';
import { Provider } from 'react-redux';

import { SvgSprite } from 'shared/components';
import { Routes } from 'routes';
import { svgSource } from 'theme';
import { store } from 'store';
import './i18n';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import 'dayjs/locale/zh-cn';
import {
  getStoredAccessToken,
  getStoredUserLanguage,
} from 'utils/localStorage';
import { logoutUser } from 'pages/signIn/signIn.service';
import dayjs from 'dayjs';
import { isTokenExpired, parseAccessToken } from 'utils/jtw';

function App(): ReactElement {
  const language = getStoredUserLanguage();
  let locale = enUS;
  if (language === 'zh-CN') {
    locale = zhCN;
  }

  const [isOver, setIsOver] = useState(false);

  const init = useCallback(async () => {
    let str = dayjs().valueOf().toString();
    // 使用 sessionStorage 标记当前标签页的唯一标识
    let tabId = sessionStorage.getItem('tabId');
    if (!tabId) {
      // 如果没有 tabId，说明是一个新标签页，生成一个新的唯一标识符
      tabId = dayjs().valueOf().toString(); // 生成唯一标识符
      sessionStorage.setItem('tabId', tabId); // 设置当前标签页的唯一标识符
    } else {
      // 如果 tabId 存在，说明是同一个标签页刷新
      const tabOpenId = sessionStorage.getItem('tabOpen');
      if (tabOpenId) {
        str = tabOpenId;
      }
      document.cookie = `tabOpen${str}=${str}; path=/`;
    }

    const cookies = document.cookie.split(';'); // 获取所有 cookies
    const testCookies: any = [];

    cookies.forEach((cookie) => {
      const [name, value] = cookie.split('=').map((c) => c.trim()); // 分离 cookie 名称和值
      if (name.startsWith('tabOpen')) {
        testCookies.push({ name, value });
      }
    });
    if (testCookies.length === 0) {
      await logoutUser();
      setIsOver(true);
      return;
    }

    document.cookie = `tabOpen${str}=${str}; path=/`;
    window.addEventListener('beforeunload', function () {
      document.cookie = `tabOpen${str}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
      sessionStorage.setItem(`tabOpen`, str);
    });
    setIsOver(true);
  }, []);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const parseAccessTokenT = parseAccessToken();
      const isTokenExpiredT = isTokenExpired();
      if (parseAccessTokenT != null && isTokenExpiredT) {
        logoutUser();
      }
    }, 1000 * 60);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <ConfigProvider locale={locale}>
      <Provider store={store}>
        {isOver && <Routes />}
        <SvgSprite symbols={svgSource} />
      </Provider>
    </ConfigProvider>
  );
}

export default App;
